/**
 * GuestbookSampleList — 에디터 미리보기용 샘플 방명록
 */

import { GuestbookEntryCard } from './GuestbookEntryCard.js'
import type { GuestbookEntryPublic } from '@cugumi/shared/schemas'

const SAMPLE_ENTRIES: GuestbookEntryPublic[] = [
  {
    id: 'sample-1',
    name: '김민지',
    message: '결혼 축하드려요! 행복하세요 :)',
    createdAt: new Date(Date.now() - 3_600_000).toISOString(),
  },
  {
    id: 'sample-2',
    name: '이준호',
    message: '두 분의 앞날에 행복만 가득하길 바랍니다. 축하합니다!',
    createdAt: new Date(Date.now() - 86_400_000).toISOString(),
  },
  {
    id: 'sample-3',
    name: '박서연',
    message: '아름다운 결혼을 진심으로 축하합니다.',
    createdAt: new Date(Date.now() - 172_800_000).toISOString(),
  },
]

export function GuestbookSampleList() {
  return (
    <>
      {SAMPLE_ENTRIES.map((entry) => (
        <GuestbookEntryCard key={entry.id} entry={entry} />
      ))}
    </>
  )
}
